import { render, staticRenderFns } from "./ConfirmCancel.vue?vue&type=template&id=f35d1a4c"
import script from "./ConfirmCancel.vue?vue&type=script&lang=js"
export * from "./ConfirmCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports